import { render, staticRenderFns } from "./DetailsOccupations.vue?vue&type=template&id=5fd338be"
import script from "./DetailsOccupations.vue?vue&type=script&lang=js"
export * from "./DetailsOccupations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports